<template>
    <div class="a-vs-aside--drawer-control" @click="toggleSideMenuMobile()">
      <img src="https://cloud.aleacontrol.com/media/vSoccer/caret-down.svg" alt="down">
      <span>{{$t('tickets')}}</span>
      <span class="a-vs-c--tickets-played">{{numberOfTickets}}</span>
    </div>
</template>
<script>

import { eventBus } from '@/main.js'
import EventConstants from '@/constants/Events'

export default {
  data () {
    return {
      numberOfTickets: 0,
      isOpen: true
    }
  },
  methods: {
    toggleSideMenuMobile: function () {
      this.isOpen = !this.isOpen
      eventBus.toggleSideMenuMobile(this.isOpen)
    },
    changeNumberOfTickets: function (length) {
      this.numberOfTickets = length
    }
  },
  created: function () {
    eventBus.$on(EventConstants.VSOCCER_CHANGE_PICKS_LENGTH, this.changeNumberOfTickets)
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VSOCCER_CHANGE_PICKS_LENGTH, this.changeNumberOfTickets)
  }
}
</script>
